exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root {\n  --tws-checklist-spacing: 1.25rem;\n}\n\n.c-checklist--touch {\n  --tws-checklist-spacing: 1.75rem;\n}\n\n.c-checklist--dense {\n  --tws-checklist-spacing: 0.75rem;\n}\n", ""]);

